import type { AxiosInstance } from 'axios';
import { initSdk } from '../target/generated/sdk';
import { getAxiosInstance, setAxiosInstance } from './axios/axios.utilities';
import { factoryOverrides } from './factoryOverrides';
import { useAxiosInstance } from './reactQuery/ApiProvider';

/** Options for configuring the generated SDK runtime. */
type SetupApiSdkOptions = {
  baseUrl: string;
  axiosInstance: AxiosInstance;
  serializeParams?: (params: Record<string, unknown>) => string;
};

let initialized = false;

/**
 * Initialize the generated SDK with base URL, hooks, and a configured axios instance.
 * Call once during app startup before using generated endpoint hooks.
 */
export function setupApiSdk({ baseUrl, axiosInstance, serializeParams }: SetupApiSdkOptions) {
  if (initialized) {
    throw new Error('API SDK has already been initialized. Multiple initializations are not supported.');
  }
  initialized = true;

  setAxiosInstance(axiosInstance);

  initSdk({
    baseUrl,
    getAxiosInstance,
    useAxiosInstance,
    serializeParams,
    factoryOverrides: factoryOverrides,
  });
}
